import { generateSetChild } from '@/helpers/VuexHelpers'
import { config } from '@/config'
import { service, contaoService } from '@/service'

export default {
  namespaced: true,
  state: {
    locations: []
  },
  actions: {
    async searchZip ({ commit, state, dispatch }, { zip, lang, orderType }) {
      try {
        const result = await contaoService.searchZip({ zip, lang: config.LANGUAGE, orderType });
        commit('setLocations', { item: result.itemlist })
      } catch (err) {
        if (err.data && err.data.itemlist.length >= 0) {
          commit('setLocations', { item: err.data.itemlist })
        } else {
          commit('setLocations', { item: [] })
        }
        throw err
      }
    },
    async loadAll ({ commit, state, dispatch }) {
      // TODO: this endpoint does not really support this, but for sake of testing....
      try {
        const result = await service.searchZip({ zip: 0, lang: config.LANGUAGE })
        commit('setLocations', { item: result.itemlist })
      } catch (err) {
        commit('setLocations', { item: [] })
        throw err
      }
    }
  },
  getters: {
    locations (state) {
      return state.locations
    },
    locationsOpen (state) {
      return state.locations
        .filter(v => v.store_temporaryclosed === '0' || v.store_temporaryclosed === 0)
    }
  },
  mutations: {
    setLocations: generateSetChild('locations')
  }
}
